/**
 * <ui-optgroup label>: a group of options in a <ui-select>. The label names
 * the group here, and ./options.css draws it. The group renders nothing of its
 * own: an option stays an option to screen readers only while its rendered
 * parent is the listbox or a group, and a shadow root's slot would sit between
 * them.
 */
export class UiOptgroup extends HTMLElement {
  static observedAttributes = [ "label" ]

  #internals = this.attachInternals()

  constructor() {
    super()
    this.#internals.role = "group"
  }

  attributeChangedCallback() {
    this.#internals.ariaLabel = this.getAttribute("label")
  }
}

customElements.define("ui-optgroup", UiOptgroup)
